import { Component,Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-message-popup',
    templateUrl: './message-popup.component.html',
    styleUrls: ['./message-popup.component.scss'],
    standalone: false
})
export class MessagePopupComponent implements OnInit {

  constructor(public routerService: Router,
    public dialogRef: MatDialogRef<MessagePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
  }

  acceptMessage(): void {
    this.dialogRef.close("yes");
  }
  close(){
    this.dialogRef.close();
  }
  closeno() {
    this.dialogRef.close(true);
  }
  yes() {
    this.dialogRef.close(false);
  }
  agree(){
    this.dialogRef.close(true);
  }
}
